import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  addNiepodjencie,
  addPodjencie,
  addZakonczeniePracy,
} from "@/service/weexpertService";
import { toast } from "@/components/ui/use-toast";
import { NIEPODJECIE, PODJECIE, ZAKONCZENIE_PRACY } from "@/constants";
import { useQueryClient } from "react-query";
import { Input } from "@/components/ui/input";
import { BaseDialog } from "../dialog";
import { DatePicker } from "@/components/ui/date-picker";
import { format, isAfter } from "date-fns";

export default function OswiadczenieAdditionalDocument(props) {
  const { clientId, oswiadczenieId, typeOfDocument, from, to} = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState();
  const queryClient = useQueryClient();

  const [date, setDate] = useState(new Date());

  const [inputChecked, setInputChecked] = useState(false);
  const [isButtonBlocked, setIsButtonBlocked] = useState(false);
  const handleUpload = () => {
    setInputChecked(true);
    if (!files) {
      toast({
        title: "Please upload a file before submitting.",
        variant: "destructive",
      });
      return;
    }
    // todo validation for each type


    setIsButtonBlocked(true);

    toast({
      title: "Starting uploading",
    });
    const getUploadFunction = (typeOfDocument) => {
      switch (typeOfDocument) {
        case NIEPODJECIE:
          return () =>
            addNiepodjencie(
              oswiadczenieId,
              files,
              clientId,
              null,
              NIEPODJECIE,
              null,
              null,
              {
                oswiadczenie: oswiadczenieId,
                date: format(date, "yyyy-MM-dd"),
              },
            );
        case PODJECIE:
          return () =>
            addPodjencie(
              oswiadczenieId,
              files,
              clientId,
              null,
              PODJECIE,
              null,
              null,
              {
                oswiadczenie: oswiadczenieId,
                date: format(date, "yyyy-MM-dd"),
              },
            );
        case ZAKONCZENIE_PRACY:
          return () =>
            addZakonczeniePracy(
              oswiadczenieId,
              files,
              clientId,
              null,
              ZAKONCZENIE_PRACY,
              null,
              null,
              {
                oswiadczenie: oswiadczenieId,
                date: format(date, "yyyy-MM-dd"),
              },
            );
        default:
          throw new Error("Unkown type");
      }
    };
    const f = getUploadFunction(typeOfDocument);
    const res = f()
      .then(() => {
        toast({
          title: "Success",
        });
      })
      .catch(() => {
        toast({
          title: "Error",
          variant: "destructive",
        });
      })
      .finally(() => {
        queryClient.invalidateQueries(["client_documents"]);
        setOpen(false);
        setIsButtonBlocked(false);
      });
  };

  return (
    <BaseDialog
      dialogTitle={""}
      buttonText={t("common:button_upload") + " " + typeOfDocument}
      open={open}
      setOpen={setOpen}
    >
      <div className="w-[400px] p-1">
        <div className="pt-4">
          <Input
            inputClassName={"h-10 mt-2  bg-white"}
            label={t("common:select_type_of_document")}
            placeholder={t("common:select_type_of_document")}
            value={typeOfDocument}
            disabled
          />
        </div>
        <div className="w-full pt-4">
          <DatePicker
            date={date}
            defaultMonth={date}
            disabled={{ before: from, after: to}}
            setDate={(e) => setDate(e)}
            error={inputChecked && (!date || isAfter(date, new Date()))}
            errorMessage={t("empty_data_invalid")}
            label={t("invoices:date_of_creation_from")}
          />
        </div>
        <div className="w-full flex justify-between pt-4">
          <div>
            <input
              ref={fileInputRef}
              accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.png,.jpg"
              multiple
              onChange={(e) => {
                setFiles(e.target.files);
              }}
              type="file"
              className="block text-sm text-gray-500 file:mr-4 file:py-2 file:px-4
                           file:rounded-sm file:border-0 file:text-sm file:font-semibold
                           file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex justify-end pt-4">
        <Button disabled={isButtonBlocked} onClick={handleUpload}>
          {t("common:button_upload")} {typeOfDocument}
        </Button>
      </div>
    </BaseDialog>
  );
}
